module.exports = __webpack_public_path__ + "static/icon__blockchain--multicolor-f9e21dbaae730a0a08264a4c89038eb6.png";